import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';
import { InViewEvent } from '@spotahome/ui-library/src/tenant/components/withInViewEvent';

import AvailabilitiesChartContainer from './AvailabilitiesChartContainer';
import PricingChartContainer from './PricingChartContainer';

import './ChartsSection.scss';
import TenantProfileChartContainer from './TenantProfilesChartContainer';
import UserInteractionChartContainer from './UserInteractionChartContainer';

const ChartsSection = ({ isMobile = false, location }) => (
  <InViewEvent className="charts-section" section="seo-charts">
    <div className="charts-section__content">
      <h2 className="charts-section__title">
        {trans('charts.main.title', { city: location.city })}
      </h2>
      <div className="charts-section__sections">
        <AvailabilitiesChartContainer isMobile={isMobile} location={location} />
        <PricingChartContainer isMobile={isMobile} location={location} />
        <TenantProfileChartContainer isMobile={isMobile} location={location} />
        <UserInteractionChartContainer location={location} />
        <p
          dangerouslySetInnerHTML={{
            __html: trans('chart.main.description')
          }}
        />
      </div>
    </div>
  </InViewEvent>
);

export default ChartsSection;

ChartsSection.propTypes = {
  isMobile: PropTypes.bool,
  location: PropTypes.shape({
    city: PropTypes.string,
    country: PropTypes.string
  }).isRequired
};
